import React from "react";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRounded from "@material-ui/icons/DeleteOutlineRounded";

/**
 * Shared row actions built from existing project atoms:
 * - Delete: MUI IconButton + DeleteOutlineRounded (RearrangeableInput pattern)
 * - Add: compact text link matching the surge mockup's "+ Add tier"
 */

/**
 * @param {{ disabled?: boolean, onClick: () => void, label?: string }} props
 */
export const TierDeleteButton = ({ disabled, onClick, label = "Remove" }) => (
  <IconButton
    size="small"
    disabled={disabled}
    onClick={onClick}
    aria-label={label}
    className="tw-text-gray-500 hover:tw-text-red-600 disabled:tw-opacity-40"
  >
    <DeleteOutlineRounded fontSize="small" />
  </IconButton>
);

/**
 * Compact text button (auto width) — matches the mockup's `.add-tier`
 * (purple text, no border/background) rather than a full-width button.
 * @param {{ disabled?: boolean, onClick: () => void, children: React.ReactNode }} props
 */
export const AddTierButton = ({ disabled, onClick, children }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className="tw-mt-2.5 tw-inline-flex tw-w-auto tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-[13px] tw-font-semibold tw-text-[#4338CA] hover:tw-underline disabled:tw-cursor-not-allowed disabled:tw-opacity-40"
  >
    {children}
  </button>
);
